/**
 * Resolve a generic "what is this row about?" title for the
 * ``ExceptionDrawer`` summary card. Configs can override via
 * ``ExceptionConfig.getRowTitle``; otherwise we fall through a small
 * list of common identity fields. No domain-specific knowledge -
 * fields are ordered most-specific first so a row with both
 * ``product_name`` and ``outlet_name`` (rare cross-domain shape)
 * still picks the product identity. ``object_id`` / ``ls_id`` sit at
 * the bottom as the last-resort UUID fallback.
 */
const CANDIDATE_FIELDS = [
  'name',
  'title',
  'product_name',
  'outlet_name',
  'register_name',
  'display_name',
  'invoice_number',
  'po_number',
  'customer_name',
  'sku',
  'code',
  'object_id',
  'ls_id',
] as const

export const getRowSummaryTitle = (row: Record<string, any>): string => {
  for (const key of CANDIDATE_FIELDS) {
    const v = row?.[key]
    if (typeof v === 'string' && v.trim() !== '') return v
    if (typeof v === 'number' && Number.isFinite(v)) return String(v)
  }
  return 'Exception row'
}
